const techCoordinatorData = [
  {
    name: "Abhishek Kumar ",
    contact: "+91 8851161189",
    // course: "B.Tech CSE",
    image: "Abhishek",
  },
  {
    name: "Anshul Tripathi ",
    contact: "+91 7417124284",
    // course: "B.Tech CSE",
    image:'Anshul'
  },
 
  
];
export default techCoordinatorData;